import React from 'react';
import { Box } from '@skin-seoul/design-system';
import * as motion from 'motion/react-client';
const MotionBox = motion.create(Box);
const ANIMATION_DURATION = 0.6;
type CenterBlurOverlayProps = {
  expandedSection: 'left' | 'right' | null;
};
const CenterBlurOverlay = ({
  expandedSection
}: CenterBlurOverlayProps) => {
  const getPosition = () => {
    if (expandedSection === null) {
      return '50%';
    }
    if (expandedSection === 'left') {
      return '100%';
    } else if (expandedSection === 'right') {
      return '0%';
    }
    return '50%';
  };
  return <MotionBox position="absolute" top="50%" left="50%" height="100%" width="fit-content" transform="translate(-50%, -50%)" display="flex" zIndex={2} pointerEvents="none" animate={{
    left: getPosition()
  }} transition={{
    duration: ANIMATION_DURATION,
    ease: 'easeInOut'
  }} data-sentry-element="MotionBox" data-sentry-component="CenterBlurOverlay" data-sentry-source-file="CenterBlurOverlay.tsx">
      <MotionBox background="linear-gradient(90deg, rgba(15, 15, 15, 0) 0%, #0f0f0f 100%)" width="182px" height="100%" animate={{
      opacity: expandedSection === 'right' ? 0 : 1
    }} data-sentry-element="MotionBox" data-sentry-source-file="CenterBlurOverlay.tsx" />
      <MotionBox background="linear-gradient(to left, rgba(255, 255, 255, 0) 0%, #fff 100%)" width="182px" height="100%" animate={{
      opacity: expandedSection === 'left' ? 0 : 1
    }} data-sentry-element="MotionBox" data-sentry-source-file="CenterBlurOverlay.tsx" />
    </MotionBox>;
};
export default CenterBlurOverlay;